"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = require("styled-components");
var _respondTo = _interopRequireDefault(require("../respondTo"));
var _createMixin = _interopRequireDefault(require("../utils/createMixin"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * bgStyling - function to map over and return the necessary css
 * @param bgImage -object containing size, position, repeat and src
 * @returns - the styling for the background image
 */
function bgStyling(bgImage) {
  var bgSizeDefault = 'cover';
  var bgPositionDefault = 'center';
  var bgRepeatDefault = 'no-repeat';
  var bgAttachmentDefault = 'scroll';
  return (0, _styledComponents.css)(["background-size:", ";background-position:", ";background-repeat:", ";background-attachment:", ";", ""], bgImage.size || bgSizeDefault, bgImage.position || bgPositionDefault, bgImage.repeat || bgRepeatDefault, bgImage.attachment || bgAttachmentDefault, bgImage.src && "\n      background-image: url(".concat(bgImage.src, ");\n    "));
}
var _default = (0, _createMixin["default"])(function (theme, bgImages) {
  return (0, _styledComponents.css)(["", " ", " ", " ", ""], bgImages.sm && bgStyling(bgImages.sm), _respondTo["default"].md((0, _styledComponents.css)(["", ""], bgImages.md && bgStyling(bgImages.md))), _respondTo["default"].lg((0, _styledComponents.css)(["", ""], bgImages.lg && bgStyling(bgImages.lg))), _respondTo["default"].xl((0, _styledComponents.css)(["", ""], bgImages.xl && bgStyling(bgImages.xl))));
});
exports["default"] = _default;